var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_vm._v("对表格中的"+_vm._s(_vm.data.length)+"条数据进行分析")]),_c('div',[_c('div',[_vm._v("端口使用率分析")]),_c('v-percent')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }